import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TokenHistory } from './token-history';
export { TokenHistory };
import { tokenHistorySchema } from '@schemas/business-objects/token-history';
import { TokenFormGroup } from './token-form-group';

export class TokenHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    activityId: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
  };

  declare value: Partial<TokenHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(tokenHistorySchema, TokenHistory, data, options);
  }

  get object(): TokenHistory {
    return new TokenHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      default:
        return undefined;
    }
  }
}

export class TokenHistoryFormArray extends PersistedFormArray {
  readonly entityName = 'TokenHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(tokenHistorySchema, TokenHistory, options);
  }

  protected override createItemGroup() {
    return new TokenHistoryFormGroup();
  }

  get array(): TokenHistory[] {
    return this.controls.map((group: TokenHistoryFormGroup) => group.object);
  }
}

export class TokenHistoryPersistedArray extends PersistedArray<TokenHistory> {
  readonly entityName = 'TokenHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TokenHistory, options);
  }
}
